module.exports = __webpack_public_path__ + "media/images/wood-wrap-1-ea56a078940158fea28a4a4a2d6edf35.jpg";